(function () {
  'use strict';

  const money = (cents) =>
    new Intl.NumberFormat(document.documentElement.lang || 'de-DE', {
      style: 'currency',
      currency: window.NiloPacks?.currency || 'EUR'
    }).format(cents / 100);

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- header condense on scroll ---------- */
  const header = document.querySelector('.site-header');
  if (header) {
    let ticking = false;
    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        header.classList.toggle('is-scrolled', window.scrollY > 24);
        ticking = false;
      });
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---------- scroll reveal ----------
     Elemente werden hier automatisch ausgezeichnet, damit die
     Sections im Theme-Editor frei von Markup-Ballast bleiben. */
  if (!reducedMotion && 'IntersectionObserver' in window) {
    const targets = document.querySelectorAll(
      '.section-head, .card, .cat-tile, .promo, .trust-item, .drop-box, .newsletter, .seo-grid > *, .collection-hero .copy, .product-info, .product-gallery'
    );
    targets.forEach((el, i) => {
      el.setAttribute('data-reveal', '');
      const within = i % 4;
      if (within > 0) el.setAttribute('data-reveal-delay', String(Math.min(within, 3)));
    });

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
    );
    targets.forEach((el) => io.observe(el));
  }

  /* ---------- mobile drawer ---------- */
  const drawer = document.querySelector('[data-drawer]');
  const overlay = document.querySelector('[data-drawer-overlay]');
  const openDrawer = (open) => {
    drawer?.classList.toggle('is-open', open);
    overlay?.classList.toggle('is-open', open);
    document.body.style.overflow = open ? 'hidden' : '';
  };
  document.querySelectorAll('[data-drawer-open]').forEach((el) =>
    el.addEventListener('click', () => openDrawer(true))
  );
  document.querySelectorAll('[data-drawer-close]').forEach((el) =>
    el.addEventListener('click', () => openDrawer(false))
  );
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') openDrawer(false);
  });

  /* ---------- cart count refresh ---------- */
  const refreshCartCount = async () => {
    const res = await fetch(window.Shopify?.routes?.root ? window.Shopify.routes.root + 'cart.js' : '/cart.js');
    const cart = await res.json();
    document.querySelectorAll('[data-cart-count]').forEach((el) => {
      el.textContent = cart.item_count;
      el.hidden = cart.item_count === 0;
    });
  };

  /* ---------- ajax add to cart ---------- */
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('[data-add-form]');
    if (!form) return;
    e.preventDefault();
    const btn = form.querySelector('[type="submit"]');
    const originalLabel = btn?.textContent;
    if (btn) {
      btn.disabled = true;
      btn.textContent = form.dataset.addingLabel || '…';
    }
    try {
      const res = await fetch('/cart/add.js', { method: 'POST', body: new FormData(form) });
      if (!res.ok) throw new Error('add failed');
      await refreshCartCount();
      if (btn) btn.textContent = form.dataset.addedLabel || '✓';
      setTimeout(() => {
        if (btn) {
          btn.textContent = originalLabel;
          btn.disabled = false;
        }
      }, 1600);
    } catch (err) {
      if (btn) {
        btn.textContent = originalLabel;
        btn.disabled = false;
      }
      form.submit();
    }
  });

  /* ---------- product gallery ---------- */
  document.querySelectorAll('[data-gallery]').forEach((gallery) => {
    const main = gallery.querySelector('[data-gallery-main]');
    gallery.querySelectorAll('[data-gallery-thumb]').forEach((thumb) => {
      thumb.addEventListener('click', () => {
        main.src = thumb.dataset.full;
        main.srcset = '';
        gallery.querySelectorAll('[data-gallery-thumb]').forEach((t) => t.classList.remove('is-active'));
        thumb.classList.add('is-active');
      });
    });
  });

  /* ---------- variant picker ---------- */
  document.querySelectorAll('[data-variant-root]').forEach((root) => {
    const variants = JSON.parse(root.querySelector('[data-variant-json]')?.textContent || '[]');
    const idInput = root.querySelector('[data-variant-id]');
    const priceEl = root.querySelector('[data-variant-price]');
    const compareEl = root.querySelector('[data-variant-compare]');
    const submitBtn = root.querySelector('[data-add-submit]');
    const stockNote = root.querySelector('[data-stock-note]');

    const update = () => {
      const selected = Array.from(root.querySelectorAll('[data-option-input]:checked')).map((i) => i.value);
      const variant = variants.find((v) => v.options.every((opt, i) => opt === selected[i]));
      if (!variant) return;
      idInput.value = variant.id;
      if (priceEl) priceEl.textContent = money(variant.price);
      if (compareEl) {
        const onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
        compareEl.hidden = !onSale;
        if (onSale) compareEl.textContent = money(variant.compare_at_price);
        priceEl?.classList.toggle('is-sale', !!onSale);
      }
      if (submitBtn) {
        submitBtn.disabled = !variant.available;
        submitBtn.textContent = variant.available
          ? submitBtn.dataset.labelAvailable
          : submitBtn.dataset.labelSoldOut;
      }
      if (stockNote) {
        stockNote.className = 'stock-note ' + (variant.available ? '' : 'is-out');
        stockNote.textContent = variant.available ? stockNote.dataset.inStock : stockNote.dataset.outOfStock;
      }
      const url = new URL(window.location);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    };

    root.querySelectorAll('[data-option-input]').forEach((input) => input.addEventListener('change', update));
  });

  /* ---------- quantity stepper ---------- */
  document.querySelectorAll('[data-qty]').forEach((wrap) => {
    const input = wrap.querySelector('input');
    wrap.querySelector('[data-qty-minus]')?.addEventListener('click', () => {
      input.value = Math.max(1, parseInt(input.value, 10) - 1);
    });
    wrap.querySelector('[data-qty-plus]')?.addEventListener('click', () => {
      input.value = parseInt(input.value, 10) + 1;
    });
  });

  /* ---------- drop countdown ---------- */
  document.querySelectorAll('[data-countdown]').forEach((el) => {
    const target = new Date(el.dataset.countdown.replace(' ', 'T')).getTime();
    if (Number.isNaN(target)) return;
    const pad = (n) => String(Math.max(0, n)).padStart(2, '0');
    const fields = {
      days: el.querySelector('[data-days]'),
      hours: el.querySelector('[data-hours]'),
      minutes: el.querySelector('[data-minutes]'),
      seconds: el.querySelector('[data-seconds]')
    };
    const tick = () => {
      const left = target - Date.now();
      if (left <= 0) {
        Object.values(fields).forEach((f) => f && (f.textContent = '00'));
        clearInterval(timer);
        return;
      }
      const s = Math.floor(left / 1000);
      if (fields.days) fields.days.textContent = pad(Math.floor(s / 86400));
      if (fields.hours) fields.hours.textContent = pad(Math.floor((s % 86400) / 3600));
      if (fields.minutes) fields.minutes.textContent = pad(Math.floor((s % 3600) / 60));
      if (fields.seconds) fields.seconds.textContent = pad(s % 60);
    };
    tick();
    const timer = setInterval(tick, 1000);
  });

  /* ---------- collection sort ---------- */
  document.querySelectorAll('[data-sort-select]').forEach((select) => {
    select.addEventListener('change', () => {
      const url = new URL(window.location);
      url.searchParams.set('sort_by', select.value);
      url.searchParams.delete('page');
      window.location.assign(url);
    });
  });

  /* ---------- facet auto-submit ---------- */
  document.querySelectorAll('[data-facet-form]').forEach((form) => {
    form.addEventListener('change', () => {
      const params = new URLSearchParams(new FormData(form));
      window.location.assign(form.action + '?' + params.toString());
    });
  });
})();
